import { brandCodeMap } from '@/constants';
import { base } from '../base';
const modalTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  modalTheme[item] = {
    modal: {
      bgColor: base[item]?.modalColor.c0002,
    },
  };
}

export const modal = modalTheme;
